<template>
  <div id="FederationPlanView" class="full-page-with-header">
    <gjw-space-header class="page-header">
      <template #customContent>
        <span class="breadcrumb">
          <span class="name-click" @click.stop="toPage('FederationPlanList')">全部合模</span>
          <span class="mg-lt-sm mg-rt-sm"> > </span>
          <img class="file-img" src="../../../assets/file/plan.png" style="margin-right: 6px;" alt="" />
          <span>{{ federationPlanName }}</span>
        </span>
        <div class="mg-sm-button">
          <el-button size="mini" @click="showDetail">详情</el-button>
          <el-button size="mini" :disabled="modelViewError" @click="toShare">分享</el-button>
          <el-button size="mini" :disabled="modelViewError" @click="toPublish">交付</el-button>
        </div>
      </template>
    </gjw-space-header>
    <div class="page-content" :class="{'error-bg': modelViewError}">
      <div v-if="modelViewError" class="error-box">
        <img src="@/assets/img/warning.png" class="warning-img" alt="">
        <span class="warning-text">该方案下无可查看模型</span>
      </div>
      <bimface
          v-else
          :key="$route.name"
          :show-error="tokenError"
          :is-multiple="true"
          :file-id="federationPlanId"
          from="FEDERATED_PLAN"
          file-type="FEDERATED_PLAN"
          :multiple-view-token="federationSuccessViewTokens"
          height="100%"
          width="100%"
      />
    </div>
    <federation-plan-detail ref="federationPlanDetail" :space-id="spaceId" />
    <!-- 分享合模方案 -->
    <model-share-dialog ref="ModelShareDialog" share-type="FEDERATED_PLAN" @share-link-opened='shareTrack' />
    <!-- 发布合模方案 -->
    <federation-publish-dialog ref="federationPublishDialog" @publish-error-detail="showDetail" />
  </div>
</template>

<script>
import GjwSpaceHeader from '@/components/business/GjwSpaceHeader.vue'
import { mapGetters, mapMutations } from 'vuex'
import Bimface from '@/components/common/Bimface.vue'
import Config from '@/config'
import FederationPlanDetail from '@/views/file/components/FederationPlanDetail.vue'
import FederationPublishDialog from '@/views/file/components/FederationPublishDialog.vue'
import ModelShareDialog from '@/views/file/components/ModelShareDialog.vue'

export default {
  name: 'FederationPlanView',
  components: { ModelShareDialog, FederationPlanDetail, Bimface, GjwSpaceHeader, FederationPublishDialog },
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      federationPlanId: this.$route.query.id,
      federationPlanName: this.$route.query.title,
      modelViewError: false,
      tokenError: false,
    }
  },
  computed: {
    ...mapGetters({
      federationPlanFileItems: 'fileModel/federationPlanFileItems',
      federationSuccessViewTokens: 'fileModel/federationSuccessViewTokens',
      federationFailFiles: 'fileModel/federationFailFiles',
    }),
  },
  created() {
    this.getFileViewTokens()
  },
  mounted() {
    if (this.$route.name === 'FederationPlanView') {
      document.title = this.$route.query.title || Config.projectName
    }
  },
  methods: {
    ...mapMutations({
      setFederationPlanFileItems: 'fileModel/setFederationPlanFileItems',
    }),
    // 根据planId获取文件的viewTokens
    async getFileViewTokens() {
      try {
        const data = await this.$api.file.federationPlanInfo(this.spaceId, this.federationPlanId)
        this.setFederationPlanFileItems(data.fileItems)
        if (!data.fileCount || !this.federationSuccessViewTokens.length) {
          this.modelViewError = true
        } else {
          this.modelViewError = false
          this.federationPlanName = data.name
          this.hasFailFile()
        }
      } catch (e) {
        this.tokenError = true
      }
    },
    // 是否有失效文件，有的话给出提示
    hasFailFile() {
      const length = this.federationFailFiles.length
      if (length) {
        const errFile = this.federationFailFiles[0]
        const errFileName = errFile.suffix ? `${errFile.fileName}.${errFile.suffix}` : errFile.fileName
        this.$confirm(`${errFileName}等${length}个文件异常，无法加载。`, {
          confirmButtonText: '查看详情',
          cancelButtonText: '关闭提示',
          showClose: false,
          type: 'warning',
        }).then(() => {
          this.showDetail()
        }).catch(() => {})
        return true
      } else {
        return false
      }
    },
    toPage(routeName) {
      this.$router.replace({ name: routeName, params: { spaceId: this.spaceId }})
    },
    // 展示详情抽屉
    showDetail() {
      this.$refs.federationPlanDetail?.openDrawer({ id: this.federationPlanId })
      this.$tracks({
        event: 'viewFederatedPlanDetail',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: this.federationPlanId,
        }
      })
    },
    // 去分享
    toShare() {
      this.$refs.ModelShareDialog?.openDialog({ id: this.federationPlanId, name: this.federationPlanName })
    },
    shareTrack(shareModelFileInfo) {
      this.$tracks({
        event: 'shareFederatedPlan',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: shareModelFileInfo.id,
        }
      })
    },
    async toPublish() {
      const row = { id: this.federationPlanId, name: this.federationPlanName }
      this.$refs.federationPublishDialog?.openDialog(row)
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  font-size: 1rem;
  font-weight: normal;
  line-height: 22px;
  color: #495f70;
  .name-click{
    cursor: pointer;
    &:hover{
      color: @theme-color;
    }
  }
  .grey-text{
    color: rgba(73, 95, 112, 0.4);
  }
}
.error-bg{
  background: url("~@/assets/img/login-bg.png") no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-box {
  width: 600px;
  height: 500px;
  background: @color-fill-white;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .warning-text {
    font-size: 16px;
    line-height: 32px;
    color: @text-tag-gery;
  }
}
</style>
